// Tenant-wide defaults applied by the backend when a client is created without explicit
// settings (portal form, quote fiche, lead conversion, Exact sync). Explicit values from the
// caller always win; the defaults only fill what is left undefined.
export interface INewClientDefaults {
    maintenanceActive: boolean;
    mailSettings: {
        disableSendMailForUpcomingMaintenance: boolean;
        disableSendMailForPlannedNotification: boolean;
        disableSendMailNotifyPlanningItemForHisAppointment: boolean;
        disableFeedbackMail: boolean;
    };
}

// Pre-feature behavior: every new client had an active maintenance contract and all mails on.
export const NEW_CLIENT_DEFAULTS_FALLBACK: INewClientDefaults = {
    maintenanceActive: true,
    mailSettings: {
        disableSendMailForUpcomingMaintenance: false,
        disableSendMailForPlannedNotification: false,
        disableSendMailNotifyPlanningItemForHisAppointment: false,
        disableFeedbackMail: false,
    },
};

// Value + merged type (see MaintenancePeriodUnit): the generated api client re-exports names as
// runtime values.
export const TenantSettingKey = {
    newClientDefaults: 'new_client_defaults',
    leadFeedback: 'lead_feedback',
    quoteMail: 'quote_mail',
    movetexAutoSend: 'movetex_auto_send',
    mailRecipients: 'mail_recipients',
} as const;
export type TenantSettingKey = (typeof TenantSettingKey)[keyof typeof TenantSettingKey];
